import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GhabzModel } from "../../../../Api/Models/GhabzModel";
import MDTypography from "../../../../Components/MDTypography";
import { v4 as uuid } from "uuid";
export default function GhabzIndex({ ghabzId }: any) {
  const navigate = useNavigate();
  const [FinalGhabz, setFinalGhabz] = useState<any>({});
  if (!ghabzId()) navigate("/notfound", { replace: true });
  var ghabzModel = new GhabzModel();
  useEffect(() => {
    ghabzModel.get(ghabzId()).then((r) => {
      setFinalGhabz(r.data.data);
      window.print();
    });
    return () => {};
  }, []);

  if (!FinalGhabz.avarezName) return null;

  return (
    <Grid container sx={{ mb: 2, border: "4px double black", mt: 1 }} textAlign="center">
      <Grid container item>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="regular">نام عوارض</MDTypography>
        </Grid>
        <Grid item xs={3} md={3} lg={3} sx={{ border: "2px black solid", borderTop: 0, borderLeft: 0 }}>
          <MDTypography fontWeight="regular">{FinalGhabz.avarezName}</MDTypography>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="regular">نام بانک</MDTypography>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
          }}
        >
          <MDTypography fontWeight="regular">{FinalGhabz.bankAccountBankName}</MDTypography>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="regular">فرمول</MDTypography>
        </Grid>
        <Grid item xs={3} md={3} lg={3} sx={{ border: "2px black solid", borderTop: 0, borderLeft: 0 }}>
          <MDTypography fontWeight="regular">{FinalGhabz.formula}</MDTypography>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="regular">پیام عوارض</MDTypography>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{
            border: "2px black solid",
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
          }}
        >
          <MDTypography fontWeight="regular">{FinalGhabz.message}</MDTypography>
        </Grid>
      </Grid>
      <Grid container item>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            borderBottom: "2px black solid",
            py: 1.5,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="bold" fontSize={16}>
            پارامتر های قبض
          </MDTypography>
        </Grid>
        <Grid container item sx={{ borderBottom: "2px black solid", py: 1.5 }}>
          {FinalGhabz.ghabzFields?.map((r: any) => {
            return (
              <Grid xs={12} md={12} lg={12} item key={uuid()}>
                <MDTypography fontWeight="bold" fontSize={16}>
                  {`${r.fieldName} (${r.symbole})`}
                </MDTypography>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid container item>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            borderBottom: "2px black solid",
            py: 1.5,
            background: "lightgray",
          }}
        >
          <MDTypography fontWeight="bold" fontSize={16}>
            شروط قبض
          </MDTypography>
        </Grid>
        <Grid container item columns={10}> 
          <Grid
            xs={2}
            md={2}
            lg={2}
            item
            sx={{
              border: "2px black solid",
              borderTop: 0,
              borderLeft: 0,
              background: "grey",
            }}
          >
            <MDTypography color="white" fontSize={16} py={0.2}>
              نماد
            </MDTypography>
          </Grid>
          <Grid
            xs={2}
            md={2}
            lg={2}
            item
            sx={{
              border: "2px black solid",
              borderTop: 0,
              borderLeft: 0,
              background: "grey",
            }}
          >
            <MDTypography color="white" fontSize={16} py={0.2}>
              مقدار کمینه
            </MDTypography>
          </Grid>
          <Grid
            xs={2}
            md={2}
            lg={2}
            item
            sx={{
              border: "2px black solid",
              borderTop: 0,
              borderLeft: 0,
              background: "grey",
            }}
          >
            <MDTypography color="white" fontSize={16} py={0.2}>
              مقدار بیشینه
            </MDTypography>
          </Grid>
          <Grid
            xs={2}
            md={2}
            lg={2}
            item
            sx={{
              border: "2px black solid",
              borderTop: 0,
              borderLeft: 0,
              background: "grey",
            }}
          >
            <MDTypography color="white" fontSize={16} py={0.2}>
              مقدار برابری
            </MDTypography>
          </Grid>

          <Grid
            xs={2}
            md={2}
            lg={2}
            item
            sx={{
              border: "2px black solid",
              borderTop: 0,
              borderLeft: 0,
              borderRight: 0,
              background: "grey",
            }}
          >
            <MDTypography color="white" fontSize={16} py={0.2}>
              مقدار پارامتر
            </MDTypography>
          </Grid>
          {FinalGhabz.ghabzRows?.map((r: any, i: number) => {
            return (
              <Grid container item key={uuid()} columns={10}>
                <Grid xs={2} md={2} lg={2} item>
                  <MDTypography color="dark" fontSize={14} py={0.2}>
                    {r.paramName || ""}
                  </MDTypography>
                </Grid>
                <Grid xs={2} md={2} lg={2} item>
                  <MDTypography color="dark" fontSize={14} py={0.2}>
                    {r.paramMin.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                  </MDTypography>
                </Grid>
                <Grid xs={2} md={2} lg={2} item>
                  <MDTypography color="dark" fontSize={14} py={0.2}>
                    {r.paramMax.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                  </MDTypography>
                </Grid>
                <Grid xs={2} md={2} lg={2} item>
                  <MDTypography color="dark" fontSize={14} py={0.2}>
                    {r?.paramEqual?.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                  </MDTypography>
                </Grid>

                <Grid xs={2} md={2} lg={2} item>
                  <MDTypography color="dark" fontSize={14} py={0.2}>
                    {r.paramAmount || ""}
                  </MDTypography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}
